import React, { useState } from "react";
import ProductGridList from "../../../components/common/ProductGridList";

const Product = () => {
  const [activeTab, setActiveTab] = useState("bestSeller");

  // const products = [
  //   // Dữ liệu sản phẩm mẫu
  //   {
  //     id: 1,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple ",
  //     price: "1,000,000đ",
  //   },
  //   {
  //     id: 2,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   {
  //     id: 3,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   {
  //     id: 4,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   {
  //     id: 5,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   {
  //     id: 6,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   {
  //     id: 7,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   {
  //     id: 8,
  //     image: ImageIphone14Pro,
  //     name: "Apple iPhone 14 Pro Max 128GB Deep Purple",
  //     price: "2,000,000đ",
  //   },
  //   // ... thêm dữ liệu
  // ];

  const tabs = [
    { id: "bestSeller", label: "Bán chạy" },
    { id: "newArrival", label: "Hàng mới về" },
    { id: "featured", label: "Sản phẩm nổi bật" },
  ];

  return (
    <div className="bg-white p-6 w-full lg:px-40">
      {/* Tabs */}
      <div className="flex flex-row justify-between lg:justify-start gap-4 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`text-primaryColor ${
              activeTab === tab.id
                ? "font-bold underline"
                : "!text-gray-500 hover:text-black"
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Product Grid */}
      <ProductGridList
        gridClassName="grid gap-4 grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 grid-rows-4 sm:grid-rows-2 lg:grid-rows-2"
        label={activeTab}
        hasPagination={false}
        showTotalRecord={false}
      />

      {/* View All */}
      <div className="mt-6 text-center">
        <a
          href={`/products/${activeTab}`}
          className="text-primaryColor underline hover:text-blue-500"
        >
          Xem tất cả sản phẩm
        </a>
      </div>
    </div>
  );
};

export default Product;
